import { Survey } from "../../types";
import { useDateFormatter, useTranslations } from "../../contexts/Translation";
import { H3 } from "../Headers/Headings";
import { useNavigate } from "react-router-dom";
import { InfoItem } from "./InfoItem";
import EmScore from "./EmScore";
import ProfileImage from "../ProfileImage";
import Card from "../Card/Card";
import styles from "./ShortView.module.css";
import AlignedContent from "../AlignedContent";

type SurveyShortViewProps = Survey & {
  title?: string;
  candidate?: string;
  cardVariant?: "floating" | "fixed" | "collapsable";
};

const SurveyShortView = ({
  cardVariant = "floating",
  candidate = "",
  createdBy,
  createdOnBehalf,
  title,
  id,
  startDate,
  changed,
  endDate,
  status,
  respondents = 0,
  invited = 0,
  score,
  profileImage,
}: SurveyShortViewProps) => {
  const t = useTranslations("surveys");
  const d = useDateFormatter();
  const navigate = useNavigate();

  return (
    <Card className={styles.card} padding='none' variant={cardVariant} onClick={() => navigate(`/survey/${id}`)}>
      {title ? (
        <H3 variant='noTopDense'>
          <div className={styles.titleRow}>
            <ProfileImage src={profileImage ? `/files/profile/${profileImage}` : ""} variant='small' alt={candidate} />
            <div>
              {title} - {candidate}
            </div>
          </div>
        </H3>
      ) : null}
      <AlignedContent className={styles.score}>
        <div className={styles.contentRow}>
          <div className={styles.info}>
            <InfoItem>{t("start", d(startDate))}</InfoItem>
            <InfoItem>{t("end", d(endDate))}</InfoItem>
            <InfoItem>{t("respondents", respondents, Math.max(invited, respondents))}</InfoItem>
            <InfoItem>{t(`status_${status}`)}</InfoItem>
          </div>
          <p className={styles.meta}>
            {createdOnBehalf ? (
              <>
                {t("creator_onBehalfOf")} <strong>{createdBy}</strong> {t("creator_for")} <strong>{candidate}</strong> - {t("changed", d(changed, true))}
              </>
            ) : (
              <>{t("changed", d(changed, true))}</>
            )}
          </p>
        </div>
        <EmScore size={5} status={status} score={score} />
      </AlignedContent>
    </Card>
  );
};

export default SurveyShortView;
